/**
 * Scope-Flag für ASL-interne Werkzeuge (Betriebsleiter Hub, ALWIS/Alvis Assistent, Control-Plane).
 * Standard: AUS. Nur ein Mandant mit settings.internal_tools = true (bzw. "true") zeigt sie.
 * Die ASL-eigene Instanz setzt das Flag; Kunden-Shops bleiben ohne Flag.
 * Unabhängig von demo_mode: Demo- und Kundenmandanten sehen die Werkzeuge nicht.
 */
export function showInternalTools(settings) {
  const v = settings?.internal_tools;
  return v === true || v === 'true';
}
